/**
 * @fileoverview SPANISH strings for `@puffin-core/auth-shell`.
 * @package @puffin-core/auth-shell
 *
 * Register is **usted**, matching every other ParcelPuffin surface (AAS-I18N-002). Machine-translated —
 * `_meta` provenance for app catalogs records `machine`, and there are zero `human` flags anywhere
 * in the ecosystem; do not invent one here.
 *
 * Key set is IDENTICAL to `en.js` by contract — `createCatalogConventionTest`-style parity depends
 * on it, and a missing key here silently degrades to English via `resolveString`.
 */

export const AUTH_SHELL_STRINGS_ES = Object.freeze({
  'authShell.skipToMainContent': 'Saltar al contenido principal',
  'authShell.goToHome': 'Ir al inicio',
  'authShell.getHelp': 'Obtener ayuda',
  'authShell.helpAndSupport': 'Ayuda y soporte',
  'authShell.help': 'Ayuda',
  // WEB-APP-VERSION-REFRESH-001 — <BuildUpdateNotice>: a newer build is ready; the reload waits for a safe moment.
  'authShell.buildUpdateReady': 'Hay una nueva versión disponible.',
  'authShell.buildUpdateRequired':
    'Esta versión está desactualizada. Recargue para seguir trabajando.',
  'authShell.buildUpdateReloadNow': 'Recargar ahora',
  'authShell.buildUpdateWaitingUnsavedChanges': 'Se actualizará cuando se guarden sus cambios.',
  'authShell.buildUpdateWaitingSaleInProgress': 'Se actualizará después de esta venta.',
  'authShell.buildUpdateWaitingSignInInProgress': 'Se actualizará después de que inicie sesión.',
  'authShell.buildUpdateWaitingRequestInFlight': 'Se actualizará en un momento.',
  // NUDGE-LINK-001 R-31 / Q-P3F-5 (2026-09-10) — the footer half, see en.js.
  'authShell.allRightsReserved': 'Todos los derechos reservados.',
  'authShell.privacyPolicy': 'Política de privacidad',
  'authShell.termsOfService': 'Términos del servicio',
  'authShell.support': 'Soporte',
  'authShell.legalLinks': 'Enlaces legales',
  // L-R7CLOSE row 32 — the password checklist, see en.js.
  'authShell.password.requirements.label': 'Su contraseña necesita',
  'authShell.password.requirement.minLength': 'Al menos {min} caracteres',
  'authShell.password.requirement.maxBytes':
    'No más de {max} bytes (las letras acentuadas y los emojis cuentan como más de uno)',
  'authShell.password.requirement.notCommon': 'Que no sea una contraseña común o fácil de adivinar',
  'authShell.password.requirement.notPersonal':
    'Que no se base en su nombre, su correo electrónico ni la palabra Puffin',
  'authShell.password.requirement.met': 'cumplido',
  'authShell.password.requirement.notMet': 'pendiente',
  'authShell.password.refused': 'No se puede usar esa contraseña. Necesita: {requirements}.',
  'authShell.credential.incorrect.password': 'Esa contraseña no es correcta. Inténtelo de nuevo.',
  'authShell.credential.incorrect.pin':
    'Ese PIN no es correcto para este dispositivo. Inténtelo de nuevo.',
  'authShell.passwordChange.title': 'Cambiar contraseña',
  'authShell.passwordChange.current': 'Contraseña actual',
  'authShell.passwordChange.new': 'Contraseña nueva',
  'authShell.passwordChange.confirm': 'Confirme la contraseña nueva',
  'authShell.passwordChange.submit': 'Cambiar contraseña',
  'authShell.passwordChange.submitting': 'Cambiando…',
  'authShell.passwordChange.mustDiffer': 'Su contraseña nueva debe ser distinta de la actual.',
  'authShell.passwordChange.confirmMismatch': 'Las dos contraseñas nuevas no coinciden.',
  'authShell.passwordChange.reused':
    'Ha usado esa contraseña recientemente. Elija una que no sea su contraseña actual ni una de las 12 anteriores.',
  'authShell.passwordChange.unchanged': 'Esa es la contraseña que usa ahora. Elija una nueva.',
  'authShell.passwordChange.accountInactive':
    'Esta cuenta no está activa, así que no se puede cambiar su contraseña. Comuníquese con su gerente.',
  'authShell.passwordChange.stepUpRequired':
    'Su empresa exige la verificación en dos pasos para cambiar una contraseña. Verifique e inténtelo de nuevo.',
  'authShell.passwordChange.notRecorded':
    'Su cambio no se realizó porque no se pudo registrar. Inténtelo de nuevo en un momento.',
  'authShell.passwordChange.tooManyAttempts':
    'Demasiados intentos. Espere unos minutos e inténtelo de nuevo.',
  'authShell.passwordChange.failed': 'No se pudo cambiar su contraseña. Inténtelo de nuevo.',
  'authShell.passwordChange.changed': 'Se cambió su contraseña.',
  'authShell.signOutOthers.prompt':
    '¿Tiene la sesión iniciada en otro lugar, como otro navegador o teléfono? Puede cerrarla en todas partes menos aquí.',
  'authShell.signOutOthers.action': 'Cerrar todas las demás sesiones',
  'authShell.signOutOthers.working': 'Cerrando sesiones…',
  'authShell.signOutOthers.done':
    'Se cerraron sus demás sesiones. Sigue con la sesión iniciada aquí.',
  'authShell.signOutOthers.failed': 'No se pudieron cerrar sus demás sesiones. Inténtelo de nuevo.',
  // PALM-PHONE-UAT-001 A6 — `<PasswordField>`'s toggle (the words `passwordChange.*` carried, moved).
  'authShell.passwordField.show': 'Mostrar contraseña',
  'authShell.passwordField.hide': 'Ocultar contraseña',
  'authShell.passwordField.showPin': 'Mostrar PIN',
  'authShell.passwordField.hidePin': 'Ocultar PIN',
  'authShell.companyBanner.login': 'Iniciando sesión en',
  'authShell.companyBanner.register': 'Registrándose en',
  'authShell.companyBanner.device': 'Registrando el dispositivo en',
});

export default AUTH_SHELL_STRINGS_ES;
